import React from 'react';
import { SpeakerWithDetails } from '@goldcast/player-config/src/types/speaker-types';
import AudiogramEmptyProfilePicture from './AudiogramEmptyProfilePicture';

const AudiogramSpeakerImage: React.FC<{ imgUrl: string | null; speaker: SpeakerWithDetails | undefined }> = ({
  imgUrl,
  speaker
}) => {
  return imgUrl ? (
    <img className="block size-full object-cover" src={imgUrl} alt="Speaker" />
  ) : (
    <AudiogramEmptyProfilePicture speaker={speaker} />
  );
};

export default AudiogramSpeakerImage;
